const roommateOptionItems = [
  {
    value: 0,
    label: '1 adult',
  },
  {
    value: 1,
    label: '2 adults',
  },
  {
    value: 2,
    label: '3 adults',
  },
  {
    value: 3,
    label: '4 adults',
  },
  {
    value: 4,
    label: '5 adults',
  },
];

export default roommateOptionItems;
